/**
 * Generates a unique ID for the session of the application.
 */
export const generateId = (() => {
  let count = 0;

  return () => {
    return (++count).toString();
  };
})();
